export const SelectStyle = {
  menu: (provided) => ({
    ...provided,
    width: '100%'
  }),
  valueContainer: (provided) => {
    return { ...provided };
  },
  container: () => ({
    // none of react-select's styles are passed to <Control />
    position: 'relative',
    display: 'inline-block',
    border: 'none',
    height: '54px'
  }),
  placeholder: (provided) => {
    const whiteSpace = 'nowrap';
    const gridArea = '1/1/2/3';
    const maxWidth = '100%';
    const overflow = 'hidden';
    const textOverflow = 'ellipsis';
    const textAlign = 'left'
    const color = 'rgb(174, 180, 186)'
    return { ...provided, whiteSpace, gridArea, maxWidth, overflow, textOverflow, textAlign, color };
  },
  control: (styles, { isDisabled }) => {
    // none of react-select's styles are passed to <Control />
    return {
      display: 'flex',
      border: 'none',
      boxShadow: 'none',
      borderRadius: '10px',
      height: '100%',
      backgroundColor: isDisabled ? 'rgb(242, 242, 242)' : '#FFFFFF'
    };
  }
};
